import { render, staticRenderFns } from "./productGroupManage.vue?vue&type=template&id=fca99bd2&scoped=true"
import script from "./productGroupManage.vue?vue&type=script&lang=js"
export * from "./productGroupManage.vue?vue&type=script&lang=js"
import style0 from "./productGroupManage.vue?vue&type=style&index=0&id=fca99bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca99bd2",
  null
  
)

export default component.exports